export const DATA_ATTR = 'toggleHidden';
export const SELECTOR = '[data-toggle-hidden]';
export const INPUT_SELECTOR = '.form-control';
